<template>
  <CustomDrawer
    v-model="showDrawer"
    :position="isMobile ? 'bottom' : 'right'"
    :width="isMobile ? 'w-full' : 'w-[35%]'"
    height="h-full"
    drawerContentClass="h-full overflow-x-scroll mx-4 md:mx-10p drawerContentContainer">
    <template #drawerContent>
      <PromotionForm
        :recovery="props.recovery"
        @showSuccessMessage="closeDrawer"
        @close="showDrawer = false" />
    </template>
  </CustomDrawer>

  <InformativeModal
    :isVisible="showSuccessMessage"
    :description="props.recovery.message_success"
    :buttonText="$t('general.closeButtonText')"
    type="success"
    @update:isVisible="handleSuccessMessageClose" />
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import CustomDrawer from '@/components/customComponents/CustomDrawer.vue';
import PromotionForm from './PromotionForm.vue';
import { useShoppingRecoveryStore } from '@/stores/shoppingRecovery.store.js';
import { useScreenSize } from '@composables/useScreenSize';
import InformativeModal from '@/components/customComponents/InformativeModal.vue';
const store = useShoppingRecoveryStore();
const { setupRecoveryBehavior, cleanupRecoveryBehavior } = store;
const { shouldShowRecovery, isInitialized } = storeToRefs(store);

const { isMobile } = useScreenSize();

const props = defineProps({
  recovery: {
    type: Object,
    required: true,
  },
});

const showDrawer = ref(false);
const showSuccessMessage = ref(false);
const closeDrawer = () => {
  showDrawer.value = false;
  showSuccessMessage.value = true;
};

const handleSuccessMessageClose = () => {
  showSuccessMessage.value = false;
};

watch(
  () => shouldShowRecovery.value.get(props.recovery.trigger),
  (shouldShow) => {
    if (shouldShow) {
      showDrawer.value = true;
    }
  },
);

watch(isInitialized, (newValue) => {
  if (newValue) {
    setupRecoveryBehavior(props.recovery);
  }
});

onMounted(() => {
  if (isInitialized) {
    setupRecoveryBehavior(props.recovery);
  }
});

onUnmounted(() => {
  cleanupRecoveryBehavior(props.recovery);
});
</script>
